import { set } from '@/utils/vuex'

export default {
  setMini: set('mini'),
  setImage: set('image'),
  setColor: set('color')
}
